import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../store/userStore";
import { searchProcess } from "../services/clientService";
import { useSelectedItemStore } from "../store/useSelectedItemStore";
import { RoutesConfig } from "../router/types";
import { signOut } from "aws-amplify/auth";
import LogoutIcon from "@mui/icons-material/Logout";

interface SearchProcessCardProps {
  onSearch?: (filters: any) => void;
}

const SearchProcessCard: React.FC<SearchProcessCardProps> = (
  props: SearchProcessCardProps
) => {
  const [filters, setFilters] = useState({
    diNumber: "",
    invoice: "",
    blNumber: "",
    containerNumber: "",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [tipoBusca, setTipoBusca] = useState<number>(0);
  const [valorBusca, setValorBusca] = useState<string>("");
  const setSelectedItemId = useSelectedItemStore((s) => s.setSelectedItemId);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (tipoBusca && valorBusca) {
      try {
        const result = await searchProcess(
          tipoBusca as 1 | 2 | 3 | 4,
          valorBusca,
          undefined
        );

        if (result && result.CD_PROCESSO) {
          setSelectedItemId(result.CD_PROCESSO);
          navigate(RoutesConfig.DETALHESPROCESSO.path);
        } else {
          toast.error("Nenhuma informação encontrada, verifique sua pesquisa!");
        }
      } catch (error) {
        console.error("Erro na busca:", error);
        toast.error("Nenhuma informação encontrada, verifique sua pesquisa!");
      }
    }
  };

  const handleLogout = async () => {
    try {
      await signOut({ global: true });
      useUserStore.getState().clearUserData();
      console.log("Usuário deslogado com sucesso");
      window.location.href = "/login";
    } catch (error) {
      console.error("Erro ao deslogar:", error);
    }
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: { xs: "200px", sm: "200px", md: "70vh" },
        boxShadow: "none",
        marginTop: "33px",
        marginBottom: "69px",
        borderRadius: "17px",
        border: "1px solid #0A0C33",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          padding: 0,
          marginTop: "18px",
        }}
      >
        <FindInPageIcon sx={{ color: "#0A0C33", fontSize: "31px" }} />
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ color: "#0A0C33", fontSize: "24px" }}
        >
          Consulta Específica
        </Typography>
      </CardContent>
      <CardContent
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box>
          <Box sx={{ flexGrow: 1, p: 3 }}>
            <Grid container spacing={4} rowSpacing={{ xs: 1, md: 4 }}>
              <Grid
                item
                xs={12}
                sx={{
                  "@media (min-width:900px)": {
                    paddingTop: "30px !important",
                  },
                  textAlign: "left",
                }}
              >
                <FormControl component="fieldset">
                  <RadioGroup
                    value={String(tipoBusca)}
                    onChange={(e) => setTipoBusca(Number(e.target.value))}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Número da DI"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="Invoice"
                    />
                    <FormControlLabel
                      value="3"
                      control={<Radio />}
                      label="House B/L"
                    />
                    <FormControlLabel
                      value="4"
                      control={<Radio />}
                      label="Número do Container"
                    />
                  </RadioGroup>
                </FormControl>
                <TextField
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 3 }}
                  value={valorBusca}
                  onChange={(e) => setValorBusca(e.target.value)}
                  placeholder="Digite o valor da busca"
                />
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              gap: 1,
              p: 2,
              borderTop: "1px solid #eee",
            }}
          >
            <Button
              size="large"
              variant="contained"
              onClick={handleSearch}
              sx={{
                textTransform: "none",
                backgroundColor: "#326AFD",
                borderRadius: "26px",
                fontWeight: 800,
              }}
            >
              Buscar
            </Button>
          </Box>
        </Box>
      </CardContent>
      {!isMobile && (
        <Box
          component="footer"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
            borderTop: "1px solid #eee",
          }}
        >
          <Button
            variant="text"
            sx={{
              color: "#326AFD",
              textTransform: "none",
              fontSize: "18px",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
            onClick={handleLogout}
          >
            <LogoutIcon sx={{ transform: "rotate(180deg)" }} />
            Sair
          </Button>
        </Box>
      )}
    </Card>
  );
};

export default SearchProcessCard;
